// extracted by mini-css-extract-plugin
export default {"modal":"VTybCmyjvSPv_HK1PuKe","wrapper":"mN6OVsV4u9B8eXy_jZJW","backBtn":"xy857yG5Vubp4spxymZj","profileWrapper":"kmzBMg8QfHmUJRciw4sw","panelsWrapper":"OYqoeqPl4KBJBisIwkRq"};